export default {
    navigationBarTitleText: '视频预览',
};
